import {useAuth} from '../../../../app/modules/auth'

const SidebarFooter = () => {
  const {currentUser} = useAuth()
  const isInterpreter = currentUser?.result?.userType === 'INTERPRETER'

  if (isInterpreter) {
    return null
  }

  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <a
        href='https://connectsupport.helpwise.help/'
        target='_blank'
        className='menu-link px-2'
        style={{color: 'rgb(163, 162, 66)'}}
      >
        <i className='bi bi-headset me-2' style={{color: 'rgb(163, 162, 66)'}}></i>
        Help Support
      </a>
    </div>
  )
}

export {SidebarFooter}
